<template>
	<div v-if="data">
		<div class="green-line">
			<div class="f34 flex flex-ai flex-jc-between">
				<div class="flex flex-ai">
					<lee-img-icon url="/images/icon/icon_31.png" size="30" color="#7ED321" class="z margin-right"></lee-img-icon>
					<div class="f22">销量分析</div>
				</div>
				<div class="flex flex-ai">
					<el-select v-model="searchData" @change="onChangeYear">
						<el-option :value="tt.value" :label="tt.timeStr" v-for="(tt,ii) in yearList"></el-option>
					</el-select>
					<el-select class="margin-left" v-model="searchQuarterData" @change="onChangeQuarter" v-if="quarterList.length > 0">
						<el-option :value="tt.value" :label="tt.timeStr" v-for="(tt,ii) in quarterList"></el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div class="margin-top-20">
			<div class="margin-top-20" v-if="data && data && data.now && data.now.content2" v-html="data.now.content2">
				{{data.now.content2 ? data.now.content2 : ''}}
			</div>
			<el-row :gutter="10">
				<el-col :span="!!searchQuarterData ? 24 : 24">
					<div class="text-center margin-top-20">
						<lee-bar-echarts
							key="bar1_1"
							ref="bar1_1"
							:grid-bottom="30"
							:grid-top="30"
							left-name="（辆）"
							height="350px"
							show-legend
						></lee-bar-echarts>
					</div>
				</el-col>
				<el-col :span="24" v-if="!!searchQuarterData && searchQuarterData !== '0'">
					<div class="text-center margin-top-20">
						<lee-bar-echarts
							key="bar1_2"
							ref="bar1_2"
							:grid-bottom="30"
							:grid-top="30"
							left-name="（辆）"
							height="350px"
							show-legend
						></lee-bar-echarts>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
export default {
	name: "CarSale",
	data() {
		return {
			yearList: [],
			quarterList: [],
			data: null,
			searchFrom:{
				year:'',
				times:'',
				time_type:'',
				type:'sale',
			},
			searchData:'',
			searchQuarterData:''
		}
	},
	created() {
	},
	mounted() {
		this.getYears();
	},
	methods: {
		onChangeTimeType(e){
			this.searchData = '';
			this.getYears();
		},
		onChangeYear(e){
			this.getMonth()
		},
		onChangeQuarter(e){
			this.getTotal1();
		},
		getYears() {
			let _this = this;

			this.$http.post({
				url: '/HydataColdCar/getYears',
				data: {type:'sale'},
				success(res) {
					_this.yearList = res;
					_this.searchData = res[0].value;
					_this.getMonth();
				}
			});
		},
		getMonth() {
			let _this = this;

			this.$http.post({
				url: '/HydataColdCar/getMonth',
				data: {year:this.searchData,type:'sale'},
				success(res) {
					if(res.length > 0) {
						_this.quarterList = res;
						_this.searchQuarterData = res[0].value;
					}else{
						_this.quarterList = [];
						_this.searchQuarterData = '';
					}
					_this.getTotal1();
				}
			});
		},
		getQuarter() {
			let _this = this;

			this.$http.post({
				url: '/HydataColdCar/getQuarter',
				data: {year:this.searchData,type:'sale'},
				success(res) {
					if(res.length > 0) {
						_this.quarterList = res;
						_this.searchQuarterData = res[0].value;
					}else{
						_this.quarterList = [];
						_this.searchQuarterData = '';
					}
					_this.getTotal1();
				}
			});
		},
		onClickMap(e){
			console.log(e);
		},
		getTotal1() {
			let _this = this;
			let _where = {};
			_where.type = 'sale';
			if(this.searchQuarterData && this.searchQuarterData !== '0'){
				_where.times = [this.searchQuarterData,'<=']
				_where.time_type = 'month';
				if(this.searchData){
					_where.year = this.searchData
				}
			}else{
				_where.time_type = 'year';
				if(this.searchData){
					_where.year = [this.searchData,'<=']
				}
			}
			this.$http.post({
				url: '/HydataColdCar/getData',
				data: _where,
				success(res) {
					_this.data = res;

					let _bardata1_1 = {bar1: [], line1: [], xaxis: []};
					let _bardata1_2 = {bar1: [], line1: [], xaxis: []};

					for (let i = 0; i < res.list.length; i++) {
						_bardata1_1.bar1.push(res.list[i].out);
						_bardata1_1.line1.push(res.list[i].huanbi);
						_bardata1_1.xaxis.push(res.list[i].time_str);
					}

					for (let i = 0; i < res.listAll.length; i++) {
						_bardata1_2.bar1.push(res.listAll[i].out);
						_bardata1_2.xaxis.push(res.listAll[i].time_str);
					}

					setTimeout(()=>{
						if (_this.$refs.bar1_1) {
							_this.$refs.bar1_1.initData(
								[
									{name: '冷藏车销量', type: 'bar', color: 'green', data: _bardata1_1.bar1, dw: '辆'},
									{name: '销量同比', type: 'line', color: 'red', data: _bardata1_1.line1, dw: '%'},
								],
								_bardata1_1.xaxis
							);
						}

						if (_this.$refs.bar1_2) {
							_this.$refs.bar1_2.initData(
								[
									{name: '冷藏车销量', type: 'bar', color: 'blue', data: _bardata1_2.bar1, dw: '辆'},
								],
								_bardata1_2.xaxis
							);
						}
					},300)
				}
			})
		},
	}
}
</script>
